import type { ColorScheme } from '../../types'

export type InfoBannerTone = 'info' | 'warning'

type InfoBannerTokens = {
  bg: string
  titleColor: string
  contentColor: string
  iconColor: string
}

export const infoBannerTokens: Record<
  ColorScheme,
  Record<InfoBannerTone, InfoBannerTokens>
> = {
  dark: {
    info: {
      bg: 'status.info-bg',
      titleColor: 'text.primary',
      contentColor: 'status.active-text',
      iconColor: 'status.info',
    },
    warning: {
      bg: 'status.warning-bg',
      titleColor: 'text.primary',
      contentColor: 'status.warning-text',
      iconColor: 'status.warning',
    },
  },
  light: {
    info: {
      bg: 'light.status.info-bg',
      titleColor: 'light.text.primary',
      contentColor: 'light.status.active-text',
      iconColor: 'light.status.info',
    },
    warning: {
      bg: 'light.status.warning-bg',
      titleColor: 'light.text.primary',
      contentColor: 'light.status.warning-text',
      iconColor: 'light.status.warning',
    },
  },
}

export const getInfoBannerTokens = (
  colorScheme: ColorScheme,
  tone: InfoBannerTone = 'info'
) => infoBannerTokens[colorScheme][tone]
